module.exports = __webpack_public_path__ + "assets/img/multi-party.901d108c.png";